/**
 * File qsp.js
 * Handles logic for addings query string params to enrollment links
 */

async function getReferralToken(urlToken) {
  const data = await callReferralApi(urlToken);
  const realToken = data?.referral_campaign?.referral_token;
  return realToken;
}

function replaceCurrentPathParam(oldParam, newParam) {
    const currentUrl = window.location.href;
    const newUrl = currentUrl.replace(oldParam, newParam);
  
    history.pushState({}, null, newUrl);
}

async function qspInit($) {
const emailPhTidInput = $('input[name="ph_tid"]');
const ssc = $('.self-service-content');
const customQspName = ssc.length > 0 ? ssc.attr('data-hidden-name') : null;
const customQspVal = ssc.length > 0 ? ssc.attr('data-hidden-value') : null;
const hasCustomQsps = customQspName && customQspVal;
const enrollLink = $('.enroll-link');
const enrollForm = $('.enroll-form');
const enrollAction = enrollForm.attr("data-action");
const pageUrl = getPath();
const pageId = getReferralId();
const urlToken = (pageId != '') ? pageUrl.split('/')[2] : null;
const token = (urlToken) ? await getReferralToken(urlToken) : null;

if (token && urlToken !== token) {
  replaceCurrentPathParam(urlToken, token);
}

// Parameter seacher
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

function checkForPhTid() {
    var phTid = getUrlParameter('ph_tid'); 
    if (phTid != '') {
        emailPhTidInput.val(phTid);
    }
}

function shouldModifyLink(link) {
  if (!link) return false;
  
  const changeLinks = [
    link.indexOf('chime.com/enroll') === -1, 
    link.indexOf('test.1debit.com/enroll') === -1,
    link.indexOf('member.chime.com/link/') === -1
  ];

  return (changeLinks.indexOf(false) > -1)
}

// Add query params to enrollment links
function getQueryString() {
    let queryString = '';
    
    // get list of search params
    const searchList = getSearchList(token, pageId);
    
    // if there is a referral token, custom qsp, or search params
    if (token || hasCustomQsps || (globalSearchParams.toString() && globalSearchParams.has(searchList[0]))) {
        
        let paramsArray = getParamsArray(searchList);
        
        // if referral page, add referral params
        addTokenQSPs(paramsArray, token, pageId)
        
        // create custom params array if custom qsps exist
        if (hasCustomQsps) {
          paramsArray.push(`${customQspName}=${customQspVal}`);
        }

        // join unique params
        queryString = '?' + getDistinctQueryString(paramsArray);
    }
    
    return queryString;
}

// Inits
checkForPhTid();

// Get updated query string
const queryString = getQueryString();

if (queryString) {
  // Add query params to enrollment urls
  if (enrollForm.length) {
    if (shouldModifyLink(enrollAction)) {
      enrollForm.attr("data-action", enrollAction + queryString);
    }
  }
  enrollLink.each(function() {
      const enrollHref = $(this).attr("href");
      if (shouldModifyLink(enrollHref)) {
        $(this).attr("href", enrollHref + queryString);
      }
  });
}

// every page of the site has an enrollment link
let prerenderEnrollmentURL = new URL(enrollLink.first().attr("href"));

// If this is a referral page append the redirect endpoint to the enrollment URL
if (urlToken) {
  prerenderEnrollmentURL.searchParams.set('ad', 'ch_raf');
  prerenderEnrollmentURL.searchParams.set('ch_rafid', urlToken);
}

addSpeculationRules(prerenderEnrollmentURL.href);

// remove the Google Analytics _gl parameter from enrollment links URLs
// it is not needed and it causes prerendering of the enrollment page to fail
enrollLink.on('click', function(event) {
  const $this = $(this);
  const href = $this.attr("href");
  const cleanUrl = new URL(href);
  cleanUrl.searchParams.delete('_gl');
  $this.attr("href", cleanUrl.toString());
});
}
